import { Button, Flex, Icon, IconButton, Text } from '@chakra-ui/react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { IoMdCloseCircle } from 'react-icons/io';

import { IconCheckCircle, IconClose, IconTrashbin } from 'assets/icons';
import { FloatingFooter } from 'components/Table';

interface IRequestsTableFooter {
  selectedFlatRows: any[];
  toggleAllRowSelected: (value?: boolean) => void;
  handleBulkDelete: (value: any[]) => void;
  handleBulkApprove: (value: any[]) => void;
  handleBulkReject: (value: any[]) => void;
}

const RequestsTableFooter: React.FC<IRequestsTableFooter> = ({
  selectedFlatRows,
  toggleAllRowSelected,
  handleBulkDelete,
  handleBulkApprove,
  handleBulkReject,
}) => {
  const { t } = useTranslation(['common']);

  let showBulkApproveButton = false;
  let showBulkRejectButton = false;

  const approvableFlatRows: any[] = [];
  const rejectableFlatRows: any[] = [];

  selectedFlatRows.forEach(row => {
    if (row.original?.can_approve && !row.original?.is_approve && !row.original?.is_reject) {
      showBulkApproveButton = true;
      approvableFlatRows.push(row);
    }

    if (row.original?.can_reject && !row.original?.is_approve && !row.original?.is_reject) {
      showBulkRejectButton = true;
      rejectableFlatRows.push(row);
    }
  });

  return (
    <FloatingFooter>
      <Flex alignItems="center" gridGap={3}>
        <IconButton
          aria-label="Close Button"
          icon={<Icon as={IconClose} h="10px" w="10px" />}
          onClick={() => toggleAllRowSelected(false)}
          variant="unstyled"
        />
        <Text>
          ({selectedFlatRows.length}) {t('common:selected')}
        </Text>
      </Flex>

      <Flex alignItems="center">
        {showBulkApproveButton && (
          <Button
            leftIcon={
              <Icon
                as={IconCheckCircle}
                sx={{
                  path: { '&:first-child': { fill: 'white' }, '&:last-child': { fill: 'success.500' } },
                }}
              />
            }
            color="white"
            bg="success.500"
            _hover={{ bg: 'success.600' }}
            _active={{ bg: 'success.600' }}
            onClick={() => handleBulkApprove(approvableFlatRows)}
            mr="3"
          >
            {t('common:approve')}
          </Button>
        )}
        {showBulkRejectButton && (
          <Button
            leftIcon={<Icon as={IoMdCloseCircle} fontSize="md" />}
            colorScheme="secondary"
            onClick={() => handleBulkReject(rejectableFlatRows)}
            mr="3"
          >
            Decline
          </Button>
        )}
        <Button
          leftIcon={
            <Icon
              as={IconTrashbin}
              sx={{
                path: { fill: 'white' },
              }}
            />
          }
          bg="newRed.1000"
          _hover={{ bg: 'newRed.1001' }}
          onClick={() => handleBulkDelete(selectedFlatRows)}
        >
          {t('common:delete')}
        </Button>
      </Flex>
    </FloatingFooter>
  );
};

export default RequestsTableFooter;
